import { defineStore } from 'pinia';
import { computed, reactive } from 'vue';

type Timers = Map<string, number>;
type Countdowns = Map<string, number>;

export const useTimersStore = defineStore('timers', () => {
    const timers = reactive<Timers>(new Map());
    const countdowns = reactive<Countdowns>(new Map());

    function setTimer(name: string, identifier: number): void {
        clearTimer(name);
        timers.set(name, identifier);
    }

    function clearTimer(name: string): void {
        if (!timers.get(name)) {
            return;
        }

        clearTimeout(timers.get(name));
        timers.set(name, null);
    }

    function setCountdown(name: string, count: number): void {
        countdowns.set(name, count);
    }

    return {
        timers: computed<Timers>(() => timers),
        countdowns: computed<Countdowns>(() => countdowns),
        setTimer,
        clearTimer,
        setCountdown
    };
});
